import React from 'react'
import { injectIntl } from 'react-intl'

import { CoverImage } from './cover-image'
import { EventTime } from './EventTime'
import { EventLocation } from './event-location'

import { eventClicked, hostClicked } from './tracking'

import locale from '../calendar/locale'
import style from './index.css'

export const MOBILE_EVENT_IMAGE_HEIGHT = 389
export const MOBILE_EVENT_IMAGE_WIDTH = 972
export const EVENT_SET = 'event_set'
export const TIMED_ENTRY = 'timed_entry'
export const eventSetOrTimedEntry = type => [EVENT_SET, TIMED_ENTRY].includes(type)

const EventCardComponent = ({ intl: { formatMessage }, ...props }) => (
  <div className={`${style.container} ${props.className ? props.className : ''}`}>
    <CoverImage coverImage={props.coverImage} url={props.url} props={props} />
    <div className={style.body}>
      <a className={style.host} href={props.hostUrl} onClick={() => hostClicked(props)}>{props.hostName}</a>
      <a className={style.title} href={props.url} onClick={() => eventClicked(props)}>{props.title}</a>

      {!props.hiddenDate &&
        <EventTime date={eventSetOrTimedEntry(props.type) ? formatMessage(locale.multipleTimeslots) : props.date} />
      }
      <EventLocation address={props.address} />
    </div>
    <div className={style.footer}>
      <a className={style.price} href={props.url}>
        {eventSetOrTimedEntry(props.type) || props.hiddenPrice ? formatMessage(locale.seeDetails) : props.price}
      </a>
    </div>
  </div>
)

export const EventCard = injectIntl(EventCardComponent)
